import { getCandidateProfileUrl } from '@/components/automation/MoveWithAutomationModal';
import type { EnqueueAutomationMoveInput } from './useEnqueueAutomationMove';
import type { WorkflowExecutionSummary } from './workflowExecutions.api';

// Derive the underway-popup enqueue input from a dispatch session's pending
// executions. Returns null when empty (e.g. every move skipped automation) so
// the caller enqueues no phantom row. No stale-row filtering: BE already
// scopes the executions to this session.
export const buildEnqueueInputFromExecutions = (
  executions: WorkflowExecutionSummary[]
): EnqueueAutomationMoveInput | null => {
  if (executions.length === 0) return null;

  const first = executions[0];
  const fallbackTarget = first.workflow_rule?.actions?.[0]?.target;
  const activityKind =
    first.next_action?.kind ?? fallbackTarget?.kind ?? 'email';
  const activityLabel =
    first.next_action?.label ?? fallbackTarget?.label ?? activityKind;

  const ruleSummary = first.workflow_rule?.summary;

  return {
    activityKind,
    activityLabel,
    stageId: ruleSummary?.ats_job_stage?.id ?? '',
    stageName: ruleSummary?.ats_job_stage?.name ?? '',
    jobId: ruleSummary?.ats_job?.id ?? '',
    jobName: ruleSummary?.ats_job?.name ?? '',
    candidates: executions.map((e) => ({
      id: String(e.subject?.id),
      name: e.subject?.name ?? `Candidate ${e.subject?.id}`,
      // Candidate-details URL for the modal name link; undefined when unresolved.
      profileUrl: getCandidateProfileUrl(e.subject) || undefined,
    })),
    isBulk: true,
    executionIds: executions.map((e) => e.id),
  };
};
